module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M27 4a1 1 0 0 0 1-1V2c0-1.106-.894-2-2-2H6C2.68 0 0 2.68 0 6v20c0 3.32 2.68 6 6 6h20c1.106 0 2-.894 2-2V10c0-1.106-.894-2-2-2H6c-1.1 0-2-.9-2-2s.9-2 2-2h21zM9 20h12a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm0-6h12a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/book-2.js
// module id = 1015
// module chunks = 14